import "./StartPage.scss";

import React, { useEffect } from "react";

import { useUserInfo } from "../../_shared/actions/useUserInfo";
import { useTeamsContext } from "../../_shared/state/TeamsContextProvider";
import { clientEventTracker } from "../../_shared/utils/clientTelemetry";
import { userIsOverUsageLimit } from "../../_shared/utils/userHelpers";
import { JTBDSelection } from "./JTBDSelection";

export const StartPage: React.FC = () => {
  const { user } = useUserInfo();
  const { teamsContext } = useTeamsContext();

  useEffect(() => {
    if (user) {
      clientEventTracker.track("StartPage viewed", user, {
        ...{
          overLimit: userIsOverUsageLimit(user),
          locale: teamsContext.app.locale,
          platform: teamsContext.app.osLocaleInfo?.platform,
          hostClientType: teamsContext.app.host.clientType,
          tenantSKU: teamsContext.user?.tenant?.teamsSku,
          theme: teamsContext.app.theme,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.userId]);

  return <JTBDSelection hostPage="start page" />;
};
